import React, { FC, ReactElement } from 'react'
import classnames from 'classnames'
import style from './TextWrapper.module.css'

type TextWrapperProps = {
  label: string
  className?: string
  description?: string
}

export const TextWrapper: FC<TextWrapperProps> = ({ label, description = '', className }): ReactElement => {
  const classNames = classnames(style.fieldLabelFormater, className)

  return (
    <span className={classNames}>
      {label}
      {description && <span className={style.description}>{description}</span>}
    </span>
  )
}
